export const classData = {
    classInput:'',
    classStart:1,
    classStartList:[],

    visbleBoolean: false,
    modeItem: [],
    itemList: [],
}